import styled from 'styled-components';
import {
  fontCondensed,
  fontDisplay,
  fontUi,
} from '../../../../theme/typography';

export const StyledPage = styled.div`
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  padding: 8px 16px 32px;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  h2 {
    ${fontDisplay};
    margin: 0;
    font-size: 22px;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledUsage = styled.span`
  ${fontUi};
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: ${({ theme }) => theme.textFaint};
  > span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.textMuted};
    font-weight: 600;
  }
  svg {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    transform: translateY(-1px);
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
`;

export const StyledRow = styled.li`
  display: grid;
  grid-template-columns: 40px minmax(160px, 0.9fr) minmax(320px, 1.35fr) 32px;
  align-items: center;
  column-gap: 12px;
  row-gap: 8px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.borderSubtle};
  border-radius: ${({ theme }) => theme.cardRadius};
  background: ${({ theme }) => theme.card};
  cursor: pointer;
  transition: border-color 150ms ease, box-shadow 150ms ease;
  &:hover {
    border-color: ${({ theme }) => theme.border};
    box-shadow: 0 8px 24px rgba(0, 0, 0, ${({ theme }) => theme.isDark ? 0.16 : 0.04});
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.headerAccent};
    outline-offset: 2px;
  }
  .star {
    display: grid;
    place-items: center;
  }
  @media (max-width: 760px) {
    grid-template-columns: 38px minmax(0, 1fr) 30px;
    column-gap: 10px;
    padding: 10px;
  }
`;

export const StyledCrest = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.textMuted};
  img {
    width: 38px;
    height: 38px;
    object-fit: contain;
  }
  .free-agent-icon > span {
    width: 26px;
    height: 26px;
  }
  .free-agent-icon svg {
    width: 26px;
    height: 26px;
  }
  .crest-placeholder {
    width: 20px;
    height: 24px;
    border: 1.5px solid ${({ theme }) => theme.textFaint};
    border-radius: 50% 50% 45% 45%;
    opacity: 0.55;
  }
`;

export const StyledIdentity = styled.div`
  min-width: 0;
`;

export const StyledPlayerLink = styled.span`
  ${fontCondensed};
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
`;

export const StyledClub = styled.div`
  ${fontUi};
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
  min-width: 0;
  @media (max-width: 760px) {
    grid-column: 2 / 4;
    grid-row: 2;
  }
`;

export const StyledMetric = styled.span`
  ${fontUi};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  gap: 1px;
  text-align: center;
  strong {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.text};
    font-size: 12px;
    font-weight: 600;
  }
  span {
    color: ${({ theme }) => theme.textFaint};
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
`;

export const StyledNote = styled.div`
  grid-column: 2 / 5;
  @media (max-width: 760px) {
    grid-column: 2 / 4;
    grid-row: 3;
  }
`;

export const StyledNoteInput = styled.input`
  ${fontUi};
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  padding: 7px 10px;
  border-radius: ${({ theme }) => theme.controlRadius};
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.inputBg || 'transparent'};
  color: ${({ theme }) => theme.text};
  font-size: 13px;
  &:focus {
    outline: 2px solid ${({ theme }) => theme.headerAccent};
    outline-offset: 2px;
  }
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  color: ${({ theme }) => theme.textMuted};
  a {
    color: ${({ theme }) => theme.button};
  }
`;
